import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import Alert from 'react-s-alert';
import queryString from 'query-string';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import Pagination from 'modules/common/components/Pagination';

import * as c from '../constant';
import * as action from '../action';
import history from '../../../../../history';

function PaymentContainer({ getPaymentList, paymentList, isLoading, pager, exportPayments }) {
  const [formData, setFormData] = useState({
    payment_date_start: '',
    payment_date_end: '',
  });
  const query = queryString.parse(window.location.search);
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  useEffect(() => {
    getPaymentList();
  }, []);

  const syncFilters = params => {
    return history.replace({
      pathname: window.location.pathname,
      search: queryString.stringify(params),
    });
  };

  const handleChangePage = page => {
    getPaymentList({ ...query, page });
    syncFilters({...query, page});
  };

  const handleDateChange = key => ({ target: { value } }) => {
    if (
      key === 'payment_date_start' &&
      `${moment(new Date(value)).format('YYYY/MM/DD')}` >
      `${moment(new Date(_.get(formData, 'payment_date_end'))).format('YYYY/MM/DD')}`
    ) {
      Alert.warning('Invalid filter, Date From is greater than Date To');

      setFormData({
        ...formData,
        [key]: '',
      });
      return;
    }

    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleSubmit = e => {
    if (
      `${moment(new Date(_.get(formData, 'payment_date_start'))).format('YYYY/MM/DD')}` >
      `${moment(new Date(_.get(formData, 'payment_date_end'))).format('YYYY/MM/DD')}`
    ) {
      Alert.warning(
        'Invalid filter, Date From is greater than selected Date To'
      );
      setFormData({
        ...formData,
        payment_date_start: '',
      });
    }

    e.preventDefault();
    const newData = {
      payment_date_start: `${moment(_.get(formData, 'payment_date_start')).format('YYYY-MM-DD')}`,
      payment_date_end: `${moment(_.get(formData, 'payment_date_end')).format('YYYY-MM-DD')}`,
    };
    getPaymentList(newData);
    syncFilters(newData);
  };

  const onClear = (e) => {
    e.preventDefault();
    setFormData({
      payment_date_start: '',
      payment_date_end: '',
    });
    syncFilters({
      payment_date_start: '',
      payment_date_end: '',
    })
    getPaymentList();
    history.replace({ pathname: window.location.pathname });
  };

  const onExport = () => (e) => {
    e.preventDefault()
    const params = {
      ...formData,
      bearer_token: token,
      email: _.get(authProfile, 'email'),
      payment_date_start: formData.payment_date_start ? `${moment(_.get(formData, 'payment_date_start')).format('YYYY-MM-DD')}` : '',
      payment_date_end: formData.payment_date_end ? `${moment(_.get(formData, 'payment_date_end')).format('YYYY-MM-DD')}` : '',
    };
    if(!formData.payment_date_start || !formData.payment_date_end) {
      delete params.payment_date_start
      delete params.payment_date_end
    }

    exportPayments(params, ({res}) => {
      Alert.success(_.get(res, 'message'));
    });
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit} className="mb-3">
        <div className="row p-3">
          <div className="col-md-12 col-lg-6 col-xl-4 px-1">
            <div className="form-input-group">
              <label className="label-reports">Date From</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('payment_date_start')}
                value={_.get(formData, 'payment_date_start') || ''}
                maxDate={new Date(_.get(formData, 'payment_date_end'))}
                endDate={new Date(_.get(formData, 'payment_date_end'))}
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4 px-1">
            <div className="form-input-group">
              <label className="label-reports">Date To</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('payment_date_end')}
                value={_.get(formData, 'payment_date_end') || ''}
                minDate={new Date(_.get(formData, 'payment_date_start'))}
              />
            </div>
          </div>
          <div className="col-12 col-xl-4 d-flex align-items-end px-1">
            <div className="form-input-group">
              <button
                disabled={
                  `${moment(new Date(_.get(formData, 'payment_date_start'))).format(
                    'YYYY/MM/DD'
                  )}` >
                  `${moment(new Date(_.get(formData, 'payment_date_end'))).format(
                    'YYYY/MM/DD'
                  )}` ||
                  _.isEmpty(_.get(formData, 'payment_date_start')) ||
                  _.isEmpty(_.get(formData, 'payment_date_end'))
                }
                type="submit"
                className="btn btn-md button-filter"
              >
                <i className="fas fa-filter" /> &nbsp;&nbsp;Filter
              </button>
            </div>
            <div className="form-input-group pl-2">
              <button
                onClick={onClear}
                type="button"
                className="btn btn-md button-clear"
              >
                <i className="fas fa-times" /> &nbsp;&nbsp; Clear
              </button>
            </div>
          </div>
        </div>
        <div className="row justify-content-end">
          <div className="col-2 d-flex justify-content-end px-1">
            <div className="form-input-group pl-2 mr-3">
              {/* <button
                onClick={onDownload}
                type="button"
                className="btn btn-md button-clear"
              >
                Download
              </button> */}
              <button
                onClick={onExport()}
                type="button"
                className="btn gen-btn btn-md btn-primary cms-bg-color-primary cms-outline-primary"
                style={{ color: 'white' }}
              >                    
                <i className="fas fa-download mr-2" /> Export
              </button>
            </div>
          </div>
        </div>
      </form>
      {isLoading ? (
        <div
          className="loading d-flex text-center justify-content-center align-items-center"
          style={{ height: '500px' }}
        >
          <div className="spinner text-center ">
            <span className="fas fa-5x fa-spin fa-spinner" />
          </div>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-sm table-bordered table-hover">
            <thead className="table-header">
              <tr>
                <th className="w-5">OR Number</th>
                <th>Payment Date</th>
                <th>Payment Method</th>
                <th>Amount</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody className="table-details">
              {paymentList.map((item) => {
                return (
                  <tr key={item.id}>
                    <td>
                      {_.get(item, 'attributes.or_number') || '---'}
                    </td>
                    <td>
                      {_.get(item, 'attributes.payment_date') ||
                        '---'}
                    </td>
                    <td>{_.get(item, 'attributes.payment_method') || '---'}</td>
                    <td>PHP {_.get(item, 'attributes.amount_human') || '---'}</td>
                    <td>
                      {_.get(item, 'attributes.remarks') || '---'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <div className="list-pagination">
        {pager.total_pages > 1 ? (
          <div className="d-flex justify-content-center text-center align-item-center">
            <Pagination data={pager} onChange={handleChangePage} />
          </div>
        ) : (
          ''
          )}
      </div>
    </React.Fragment>
  );
}

PaymentContainer.propTypes = {
  exportPayments: PropTypes.instanceOf(Function).isRequired,
  getPaymentList: PropTypes.instanceOf(Function).isRequired,
  paymentList: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  paymentList: _.get(api, `${c.PAYMENT_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.PAYMENT_LIST) > -1,
  pager: _.get(api, `${c.PAYMENT_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(PaymentContainer);
